import apiService from '@/modules/api/csp'

export const getCallDetailNotes = async ({ commit }, payload = []) => {
  return await apiService.callNotes.list(payload)
}

export const saveCallDetailNotes = async ({ commit }, payload = []) => {
  return await apiService.callNotes.create(payload)
}
